import React, { useState, useEffect } from 'react'
import './A1MenuButtons.css';

const A1MenuButtons = (props) => {
    const { data, addMessages, createOrderRequest, msg, showMaximumChat, setIsShowMaximumChat, loading, scrollToBottom, viewMenuInfo } = props
    
    const [clickedIndex, setClickedIndex] = useState(null)
    const [isOpen, setIsOpen] = useState(true)
    const [userClosed, setUserClosed] = useState(false)

    const item = data?.data ? JSON.parse(data.data) : null
    const disabledMappedIds = viewMenuInfo ? viewMenuInfo.split(',').map(i => parseInt(i.trim())) : []
    const isButtonDisabled = (button) => disabledMappedIds.includes(button.mappedId)
  
    const hasData = item && item.length > 0

    useEffect(() => {
        if (!loading) {
            setClickedIndex(null)
        }
    }, [loading])

    if (!hasData) {
        return null
    }

    if (!showMaximumChat) {
        return null
        return (
            <div className="">
                {/* <div className="quick-actions-header">Quick Actions</div> */}
                <div className="quick-actions-buttons">
                    {item?.slice(0, 3).map((button, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                setClickedIndex(index)
                                addMessages(`{${button?.buttonName}- QA}`, button?.buttonOpCode, button?.buttonName, `${button?.buttonName}-QA`, null, "MenuButton")
                                scrollToBottom?.()
                            }}
                            className="menu-button"
                            disabled={loading || clickedIndex !== null}
                        >
                            {button?.buttonName}
                        </button>
                    ))}
                    {/* <button
                        onClick={() => {
                            setClickedIndex(0)
                            addMessages(item[0]?.buttonName, "#2.16", item[0]?.buttonName, null, null, "MenuButton")
                        }}
                        className="menu-button"
                        disabled={clickedIndex !== null}
                    >
                        Explore All Packs
                    </button>
                    <button
                        onClick={() => {
                            setClickedIndex(0)
                            addMessages(item[0]?.buttonName, "#2.13", item[0]?.buttonName, null, null, "MenuButton")
                        }}
                        className="menu-button"
                        disabled={clickedIndex !== null}
                    >
                        Pack details
                    </button>
                    <button
                        onClick={() => {
                            setClickedIndex(0)
                            addMessages(item[0]?.buttonName, "#2.12", item[0]?.buttonName, null, null, "MenuButton")
                        }}
                        className="menu-button"
                        disabled={clickedIndex !== null}
                    >
                        Balance & Due date
                    </button> */}
                </div>
            </div>
        )
    }

    const checkEndpoint = (button) =>{

        if(button?.endpoint === "storeCurrentOpNode"){
            return "MenuButton"
        }

        return null


    }

    return (
        <div className={`quick-actions-sidebar ${isOpen ? 'open' : 'closed'}`}>
            <button className="toggle-btn" onClick={() => {
                setIsOpen(!isOpen)
                setUserClosed(isOpen)
            }}>
                {isOpen ? '>' : '<'}
            </button>
            {isOpen && (
                <>
                    <div className="sidebar-header">Quick Actions</div>
                    <div className="sidebar-buttons">
                        {item?.map((button, index) => (
                            <button
                                key={index}
                                onClick={() => {
                                    setClickedIndex(index)
                                    addMessages(`${button?.buttonName}- QA`, button?.buttonOpCode, button?.buttonName, `${button?.buttonName} - QA`, null, checkEndpoint(button))
                                    scrollToBottom?.()
                                }}
                                className="sidebar-menu-button"
                                disabled={loading || clickedIndex !== null || isButtonDisabled(button)}
                            >
                                {button?.buttonName}
                            </button>
                        ))}
                        {/* <button
                            onClick={() => {
                                setClickedIndex(0)
                                addMessages(item[0]?.buttonName, "#2.16", item[0]?.buttonName, null, null, "MenuButton")
                            }}
                            className="sidebar-menu-button"
                            disabled={clickedIndex !== null}
                        >
                            Explore All Packs
                        </button>
                        <button
                            onClick={() => {
                                setClickedIndex(0)
                                addMessages(item[0]?.buttonName, "#2.13", item[0]?.buttonName, null, null, "MenuButton")
                            }}
                            className="sidebar-menu-button"
                            disabled={clickedIndex !== null}
                        >
                            Pack details
                        </button>
                        <button
                            onClick={() => {
                                setClickedIndex(0)
                                addMessages(item[0]?.buttonName, "#2.12", item[0]?.buttonName, null, null, "MenuButton")
                            }}
                            className="sidebar-menu-button"
                            disabled={clickedIndex !== null}
                        >
                            Balance & Due date
                        </button> */}
                    </div>
                </>
            )}
        </div>
    )
}

export default A1MenuButtons
